import { EntityService } from './EntityService';
import { IUserRole} from '../types';
import { AppGlobals } from '../AppGlobals';

export class UserRoleService extends EntityService<IUserRole> {
    private zedxApiURL: string = process.env.REACT_APP_ZedX_Non_Odata_API!;
    constructor() {
        super(`/UserRoles`);
    }

    // public readAllForList(): Promise<IUserRole[]> {
    //     return this.readAll(`?$orderby=User/Title&$expand=User,Role`);
    // }

    public readAllForList2(): Promise<any> {
        const endPoint: string = `${this.zedxApiURL}/Accounts/GetUserRoles`;
        const result = super.readAnyEndPointValue(endPoint);
        return result;
    }

    public checkForDuplicates = (userId: number, roleId: number): Promise<IUserRole[]> => {
        return this.readAll(`?$filter=UserID eq ${userId} and RoleID eq ${roleId}&$select=ID`);
    }
}